import React from 'react';
import {
    Filter,
    List,
    Edit,
    Create,
    Show,
    Datagrid,
    EmailField,
    TextField,
    DateField,
    ReferenceArrayField,
    SingleFieldList,
    ChipField,
    SimpleForm,
    TextInput,
    DisabledInput,
    SelectInput,
    ReferenceInput,
    ReferenceArrayInput,
    SelectArrayInput,
    EditButton,
    DeleteButton,
    ShowButton,
    ReferenceField,
    TabbedShowLayout,
	Tab,
	TabbedForm,
	FormTab
} from 'react-admin';
import EntityRefField from '../components/entityRefField';

import { withStyles } from '@material-ui/core/styles';

const styles = {
    userTab: {
        fontWeight: 'bold',
		color: 'lightgray'
    }
};

const UserTab = withStyles(styles)(({ classes, ...props }) => (
	<Tab
		className={classes.userTab}
		{...props}
	/>
));

const UserFormTab = withStyles(styles)(({ classes, ...props }) => (
	<FormTab
		className={classes.userTab}
		{...props}
	/>
));

const UserFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Search" source="q" alwaysOn />
        <ReferenceInput label="Sites" source="Sites" reference="Site" allowEmpty>
            <SelectInput optionText="Name" />
        </ReferenceInput>
        <ReferenceInput label="Clients" source="Clients" reference="Client" allowEmpty>
            <SelectInput optionText="Name" />
		</ReferenceInput>
		<ReferenceInput label="Roles" source="Roles" reference="Role" allowEmpty>
			<SelectInput optionText="Name" />
		</ReferenceInput>
    </Filter>
);

export const UserList = (props) => (
	<List title="Users" {...props} filters={<UserFilter />} sort={{ field: 'LastName', order: 'ASC' }} >
        <Datagrid>
			<TextField source="LastName" />
            <TextField source="FirstName" />
			<EmailField source="Email" />
			<ReferenceArrayField label="Sites" reference="Site" source="Sites">
				<SingleFieldList linkType="show">
					<ChipField source="Name" />
				</SingleFieldList>
			</ReferenceArrayField>
			<ReferenceArrayField label="Clients" reference="Client" source="Clients">
				<SingleFieldList linkType="show">
					<ChipField source="Name" />
				</SingleFieldList>
			</ReferenceArrayField>
			<ReferenceArrayField label="Roles" reference="Role" source="Roles">
				<SingleFieldList linkType="show">
					<ChipField source="Name" />
				</SingleFieldList>
			</ReferenceArrayField>
            <ShowButton />
            <EditButton />
			<DeleteButton />
        </Datagrid>
    </List>
);

const UserTitle = ({ record }) => {
	return <span>{record ? `"${record.FirstName ? record.FirstName : ''} ${record.LastName ? record.LastName : ''}"` : ''}</span>;
};

export const UserShow = (props) => (
    <Show title={<UserTitle />} {...props}>
        <TabbedShowLayout>
            <UserTab label="Summary">
                <TextField source="id" />
				<TextField source="FirstName" />
				<TextField source="LastName" />
				<EmailField source="Email" />
				<TextField source="PhoneNumber" />
				<ReferenceField label="Supplier" source="Supplier" reference="Supplier" linkType="show">
					<TextField source="Name" />
				</ReferenceField>
				<ReferenceField label="DefaultSite" source="DefaultSite" reference="Site" linkType="show">
					<TextField source="Name" />
				</ReferenceField>
				<ReferenceField label="DefaultClient" source="DefaultClient" reference="Client" linkType="show">
					<TextField source="Name" />
				</ReferenceField>
            </UserTab>
            <UserTab label="Sites">
                <ReferenceArrayField label="Sites" reference="Site" source="Sites">
					<Datagrid>
						<TextField source="Name" />
						<ReferenceField label="Client" source="Client" reference="Client" linkType="show">
							<TextField source="Name" />
						</ReferenceField>
						<TextField label="Suburb" source="Address.Suburb" />
						<TextField label="State" source="Address.State" />
						<TextField label="Country" source="Address.Country" />
                        <ShowButton />
                    </Datagrid>
                </ReferenceArrayField>
            </UserTab>
            <UserTab label="Clients">
                <ReferenceArrayField label="Clients" reference="Client" source="Clients">
                    <Datagrid>
                        <TextField source="id" />
                        <TextField source="Name" />
                        <ShowButton />
                    </Datagrid>
                </ReferenceArrayField>
            </UserTab>
            <UserTab label="Roles">
                <ReferenceArrayField label="Roles" reference="Role" source="Roles">
                    <Datagrid>
                        <TextField source="id" />
                        <ReferenceField label="Parent" source="Parent" reference="Role" linkType={false}>
                            <EntityRefField source="Name" />
                        </ReferenceField>
                        <TextField source="Name" />
                        <TextField source="Description" />
                        <ShowButton />
                    </Datagrid>
                </ReferenceArrayField>
            </UserTab>
        </TabbedShowLayout>
    </Show>
);

const required = (message = 'Required') =>
    value => value ? undefined : message;
const isEmail = (message = 'Not a valid email') => value => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(value) ? undefined : message;
};

const validateName = [required()];
const validateEmail = [required(), isEmail()];

export const UserEdit = (props) => (
    <Edit title={<UserTitle />} {...props}>
		<TabbedForm submitOnEnter={false}>
			<UserFormTab label="Details">
				<DisabledInput source="id" />
				<TextInput source="FirstName" validate={validateName} required />
				<TextInput source="LastName" validate={validateName} required />
				<TextInput source="Email" validate={validateEmail} type="email" required />
				<TextInput source="PhoneNumber" />
				<br /><br />
				<ReferenceInput label="Supplier" source="Supplier" reference="Supplier">
					<SelectInput optionText="Name" />
				</ReferenceInput>
				<ReferenceInput label="DefaultSite" source="DefaultSite" reference="Site">
					<SelectInput optionText="Name" />
				</ReferenceInput>
				<ReferenceInput label="DefaultClient" source="DefaultClient" reference="Client">
					<SelectInput optionText="Name" />
				</ReferenceInput>
			</UserFormTab>
			<UserFormTab label="References">
				<ReferenceArrayInput label="Sites" source="Sites" reference="Site" allowEmpty>
					<SelectArrayInput optionText="Name" />
				</ReferenceArrayInput>
				<ReferenceArrayInput label="Clients" source="Clients" reference="Client" allowEmpty>
					<SelectArrayInput optionText="Name" />
				</ReferenceArrayInput>
				<ReferenceArrayInput label="Roles" source="Roles" reference="Role" allowEmpty>
					<SelectArrayInput optionText="Name" />
				</ReferenceArrayInput>
			</UserFormTab>
		</TabbedForm>
    </Edit>
);

export const UserCreate = (props) => (
	<Create title="Create User" {...props}>
		<TabbedForm submitOnEnter={false}>
			<UserFormTab label="Details">
				<TextInput source="FirstName" validate={validateName} required />
				<TextInput source="LastName" validate={validateName} required />
				<TextInput source="Email" validate={validateEmail} type="email" required />
				<TextInput source="PhoneNumber" />
				<br /><br />
				<ReferenceInput label="Supplier" source="Supplier" reference="Supplier">
					<SelectInput optionText="Name" />
				</ReferenceInput>
				<ReferenceInput label="DefaultSite" source="DefaultSite" reference="Site">
					<SelectInput optionText="Name" />
				</ReferenceInput>
				<ReferenceInput label="DefaultClient" source="DefaultClient" reference="Client">
					<SelectInput optionText="Name" />
				</ReferenceInput>
			</UserFormTab>
			<UserFormTab label="References">
				<ReferenceArrayInput label="Sites" source="Sites" reference="Site" allowEmpty>
					<SelectArrayInput optionText="Name" />
				</ReferenceArrayInput>
				<ReferenceArrayInput label="Clients" source="Clients" reference="Client" allowEmpty>
					<SelectArrayInput optionText="Name" />
				</ReferenceArrayInput>
				<ReferenceArrayInput label="Roles" source="Roles" reference="Role" allowEmpty>
					<SelectArrayInput optionText="Name" />
				</ReferenceArrayInput>
			</UserFormTab>
		</TabbedForm>
    </Create>
);



// WEBPACK FOOTER //
// ./src/resources/users.js